<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M16.1145 2.25H12.786V15.7029C12.786 17.3058 11.5059 18.6225 9.91278 18.6225C8.31967 18.6225 7.0395 17.3058 7.0395 15.7029C7.0395 14.1286 8.29122 12.8406 9.82745 12.7833V9.40581C6.44209 9.46303 3.71106 12.2395 3.71106 15.7029C3.71106 19.195 6.49898 22 9.94124 22C13.3834 22 16.1714 19.1663 16.1714 15.7029V8.8047C17.4231 9.72066 18.9593 10.2645 20.5809 10.2931V6.91558C18.0774 6.82971 16.1145 4.76884 16.1145 2.25Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
